export default __webpack_public_path__ + "38c54dbe80c6793655d98caa571f8ab8.png";